import type { LeDataImageAttachment, LeDataImageMediaType } from '~/types/leData';

export const MAX_COMPOSER_IMAGES = 5;
export const MAX_COMPOSER_IMAGE_BYTES = 5 * 1024 * 1024;

const ALLOWED_COMPOSER_IMAGE_TYPES = new Set<LeDataImageMediaType>([
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
]);

export const COMPOSER_IMAGE_ACCEPT = [...ALLOWED_COMPOSER_IMAGE_TYPES].join(',');

export function imageAttachmentError(file: Pick<File, 'size' | 'type'>): string | null {
  if (file.size > MAX_COMPOSER_IMAGE_BYTES) {
    return 'That image is larger than 5 MB.';
  }
  if (!ALLOWED_COMPOSER_IMAGE_TYPES.has(file.type as LeDataImageMediaType)) {
    return 'Paste a PNG, JPG, GIF or WebP image.';
  }
  return null;
}

export function fileToComposerImageAttachment(file: File): Promise<LeDataImageAttachment> {
  return new Promise((resolve, reject) => {
    const validationError = imageAttachmentError(file);
    if (validationError) {
      reject(new Error(validationError));
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const data = typeof reader.result === 'string' ? reader.result.split(',')[1] : undefined;
      if (!data) {
        reject(new Error('That image could not be read.'));
        return;
      }
      resolve({ data, mediaType: file.type as LeDataImageMediaType });
    };
    reader.onerror = () => reject(new Error('That image could not be read.'));
    reader.readAsDataURL(file);
  });
}
